var _jsxFileName = "/home/circleci/NACL/NACL/packages/nr-vamp-xl-icon-button/src/IconButton.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { NikeStylesContext } from '@nike/nr-sole-xl-theme-provider';
import IconButtonPure from './IconButtonPure';
import defaultStyles from './styles';

var IconButton = function IconButton(_ref) {
  var styleExtension = _ref.styleExtension,
      rest = _objectWithoutProperties(_ref, ["styleExtension"]);

  return React.createElement(NikeStylesContext.Consumer, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: this
  }, function (_ref2) {
    var attributes = _ref2.attributes,
        merge = _ref2.merge,
        globalStyleExtension = _ref2.styleExtension;
    var globalStyles = merge(defaultStyles(attributes), globalStyleExtension.IconButton);
    var localStyles = merge(globalStyles, styleExtension);
    return React.createElement(IconButtonPure, _extends({
      styles: localStyles
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      },
      __self: this
    }));
  });
};

IconButton.propTypes = {
  /** State of icon button. */
  checked: PropTypes.bool,

  /** Passed down to all children to allow for E2E testing. */
  'data-e2e': PropTypes.string,

  /** If true, icon button is disabled. */
  disabled: PropTypes.bool,

  /** Font awesome icon to use as button. */
  icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.element, PropTypes.object, PropTypes.string]),

  /** Passed down to all DOM elements to allow E2E testing. */
  id: PropTypes.string,

  /** If true, icon button is inline. */
  inline: PropTypes.bool,

  /** Icon button label. */
  label: PropTypes.string,

  /** Position of icon button label. */
  labelPosition: PropTypes.string,

  /** Callback fired on check. */
  onCheck: PropTypes.func,

  /** If true, label is visible. */
  showLabel: PropTypes.bool,

  /** Extends and overrides styles. */
  styleExtension: PropTypes.shape({
    container: PropTypes.shape({}),
    containerInline: PropTypes.shape({}),
    containerLeft: PropTypes.shape({}),
    iconStyle: PropTypes.shape({}),
    iconStyleChecked: PropTypes.shape({}),
    iconStyleDisabled: PropTypes.shape({}),
    labelStyleLeft: PropTypes.shape({}),
    labelStyleLeftDisabled: PropTypes.shape({}),
    labelStyleRight: PropTypes.shape({}),
    labelStyleRightDisabled: PropTypes.shape({})
  })
};
IconButton.defaultProps = {
  styleExtension: {
    container: {},
    containerInline: {},
    containerLeft: {},
    iconStyle: {},
    iconStyleChecked: {},
    iconStyleDisabled: {},
    labelStyleLeft: {},
    labelStyleLeftDisabled: {},
    labelStyleRight: {},
    labelStyleRightDisabled: {}
  }
};
IconButton.displayName = 'IconButton';
export default IconButton;